import { makeToolProviders } from '../../cross-team-shared/annotation/shared/abstract-tool';
import { contentProviders } from '../../cross-team-shared/content-providers';
import { ContextMenuOptionsService } from './context-menu-options.service';
import { MouseCoordinateService } from './mouse-coordinate.service';
import { RedrawService } from './redraw.service';
import { InspectService } from './toolbars/inspect.service';
import { ArrowTool } from './tools/arrow/arrow-tool';
import { CuboidTool2D } from './tools/cuboid/cuboid-tool-2d';
import { AddRemoveModeHelperService } from './tools/edit/add-remove-mode-helper.service';
import { EditTool2D } from './tools/edit/edit-tool-2d';
import { ImageBoundsService } from './tools/edit/image-bounds.service';
import { KeypointTool } from './tools/keypoint/keypoint-tool';
import { LineTool } from './tools/line/line-tool';
import { MeasureTool } from './tools/measure/measure-tool';
import { PointTool } from './tools/point/point-tool';
import { PolygonInferenceService } from './tools/polygon/polygon-inference.service';
import { PolygonTool } from './tools/polygon/polygon-tool';
import { RectangleTool } from './tools/rectangle/rectangle-tool';
import { SelectTool2D } from './tools/select/select-tool-2d';
import { CrosshairService } from './tools/shared/crosshair.service';
import { ToolManager2DService } from './tools/shared/tool-manager-2d.service';
import { SliderRectangleTool } from './tools/slider-rectangle/slider-rectangle-tool';
import { ZoomTool } from './tools/zoom/zoom-tool';
import { ExtrapolationService } from './utils/extrapolation/extrapolation.service';
import { PanningService } from './utils/panning.service';
import { RectangleExpandContractService } from './utils/rectangle-expand-contract.service';
import { ShapeBoundingPointsService } from './utils/shape-bounding-points.service';
import { ShapeTranslationService } from './utils/shape-translation.service';
import { ShapeValidationService } from './utils/shape-validation.service';
import { SliderRectangleSliderTranslationService } from './utils/slider-rectangle-slider-translation.service';
import { SubpointSelectionService } from './utils/subpoint-selection.service';
import { ViewBoxBuilderService } from './utils/view-box-builder.service';
import { ViewBoxClampingService } from './utils/view-box-clamping.service';
import { ViewBoxPaddingService } from './utils/view-box-padding.service';
import { ViewBoxService } from './utils/view-box.service';
import { VectorRendererCssPropertyService } from './vector-renderer/vector-renderer-css-property.service';
import { VectorRendererCursorCssPropertyService } from './vector-renderer/vector-renderer-cursor-css-property.service';

export const contentProviders2D = [
  contentProviders,
  ContextMenuOptionsService,
  AddRemoveModeHelperService,
  ImageBoundsService,
  ExtrapolationService,
  ShapeBoundingPointsService,
  MouseCoordinateService,
  CrosshairService,
  InspectService,
  PanningService,
  PolygonInferenceService,
  RectangleExpandContractService,
  RedrawService,
  ShapeTranslationService,
  ShapeValidationService,
  SliderRectangleSliderTranslationService,
  SubpointSelectionService,
  ToolManager2DService,
  VectorRendererCssPropertyService,
  VectorRendererCursorCssPropertyService,
  ViewBoxService,
  ViewBoxPaddingService,
  ViewBoxBuilderService,
  ViewBoxClampingService,
  makeToolProviders(
    ArrowTool,
    CuboidTool2D,
    EditTool2D,
    KeypointTool,
    LineTool,
    MeasureTool,
    PointTool,
    PolygonTool,
    RectangleTool,
    SelectTool2D,
    SliderRectangleTool,
    ZoomTool,
  ),
];
